module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-xy-center",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "loading-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "lds-ring",
    class: _vm.size ? _vm.size : 'default'
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b736bdde","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/g_plugin/icon/LoadingMask.vue
// module id = 1992
// module chunks = 1